import React from 'react';
import GraphAndTableAnalytics from './GraphAndTableAnalytics';
import { useSelector } from 'react-redux';

export default function CourseAnalytics({ bgcolor }) {
  const courseTrend = useSelector((state) => state.pointTracker.courseTrend.data);
  const courseTrendLoading = useSelector((state) => state.pointTracker.courseTrend.loading);

  return (
    <GraphAndTableAnalytics
      bgcolor={bgcolor}
      loading={courseTrendLoading}
      rows={[...(courseTrend?.trends || []), { month: 'TOTAL', ...(courseTrend?.totals || {}) }]}
    />
  );
}
